import React, { useState } from "react";
import { Modal, Button, Input, message } from "antd";
import { MailOutlined } from "@ant-design/icons";
import { apiRequest } from "../../utilities/apiMethod";

export const ForgotPasswordModal = ({ open, onCancel }) => {
  const [messageApi, contextHolder] = message.useMessage();
  const [userIdentifier, setUserIdentifier] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (value) => {
    setUserIdentifier(value);
    if (error) {
      setError("");
    }
  };

  const validateForm = () => {
    if (!userIdentifier || userIdentifier.trim() === "") {
      setError("Username/Email is required");
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      return;
    }

    try {
      setLoading(true);
      const payload = {
        userIdentifier: userIdentifier.trim(),
      };

      const response = await apiRequest("POST", "Users/forgotpassword", payload);

      if (response.IsSuccess) {
        messageApi.success(
          response.DisplayMessage || "Password details sent to your email successfully!"
        );
        // Reset form
        setUserIdentifier("");
        setError("");
        // Close modal after short delay to show success message
        setTimeout(() => {
          onCancel();
        }, 1500);
      } else {
        if (response.ErrorMessage && response.ErrorMessage.length > 0) {
          response.ErrorMessage.forEach((err) => {
            messageApi.error(err);
          });
         
        } else {
          messageApi.error(
            response.DisplayMessage || "Failed to send password details"
          );
           
        }
      }
    } catch (error) {
      console.error("Error in forgot password:", error);
    //   messageApi.error(
    //     "An error occurred while processing your request. Please try again."
    //   );
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setUserIdentifier("");
    setError("");
    onCancel();
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSubmit();
    }
  };

  return (
    <>
      {contextHolder}
      <Modal
        key="forgotPasswordForm"
        open={open}
        title="Forgot Password"
        onCancel={handleCancel}
        footer={[
          <Button key="cancel" onClick={handleCancel} disabled={loading}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={handleSubmit}
            loading={loading}
          >
            Send
          </Button>,
        ]}
        width={450}
      >
        <div style={{ marginTop: "20px", marginBottom: "10px" }}>
          <p style={{ marginBottom: "15px", color: "#666" }}>
            Enter your username or email address and we'll send your password
            details to your registered email.
          </p>

          <Input
            prefix={<MailOutlined style={{ color: "#bfbfbf" }} />}
            name="userIdentifier"
            id="userIdentifier"
            type="text"
            placeholder="Enter Username or Email"
            size="large"
            value={userIdentifier}
            onChange={(e) => handleChange(e.target.value)}
            onKeyPress={handleKeyPress}
            status={error ? "error" : ""}
          />
          {error && (
            <div style={{ color: "#ff4d4f", fontSize: "12px", marginTop: "5px" }}>
              {error}
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};